import React from 'react';
import { FadeIn } from './FadeIn';

export default function Expectations() {
  const experiences = [
    { title: "Guided Walkthrough", desc: "A personalized 60-minute tour of our ceremony sites, the historic ballroom, and the terrace, designed for you and your key decision-makers." },
    { title: "Vision & Layout", desc: "Explore the natural flow of your day, from your arrival in the bridal suite to your final sunset toast on the olive grove terrace." },
    { title: "Investment Clarity", desc: "Receive a personalized estimate during your visit, tailored to your guest count, preferred season, and specific event requirements." },
    { title: "Real-Time Answers", desc: "Speak directly with our coordination team about availability, custom enhancements, and the seamless Padua planning experience." }
  ];

  return (
    <section className="py-20 md:py-32 lg:py-40 bg-vintage-white px-6">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-start">
          {/* Left Column - Optimized Sticky Behavior */}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <FadeIn direction="right">
              <span className="uppercase tracking-[0.5em] text-estate-bronze text-[10px] font-bold mb-5 block">
                The Experience
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl text-deep-charcoal mb-8 leading-[1.1] text-balance">
                An Immersive Perspective
              </h2>
              <p className="text-base md:text-lg text-deep-charcoal/70 font-light leading-relaxed mb-10 max-w-md">
                Your wedding deserves to be felt before it is finalized. We invite you to step into the heritage and atmosphere of Padua.
              </p>
              <div className="aspect-[4/5] md:aspect-[3/4] overflow-hidden rounded-2xl shadow-2xl relative group">
                <img 
                  src="https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/_MG_7189%20E1.jpg?updatedAt=1778006788243" 
                  alt="Padua Weddings Atmosphere" 
                  className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-deep-charcoal/10 group-hover:bg-transparent transition-colors duration-700"></div>
              </div>
            </FadeIn>
          </div>

          {/* Right Column - List Items */}
          <div className="lg:col-span-7 pt-4 lg:pt-12">
            <div className="grid grid-cols-1 gap-10 md:gap-16">
              {experiences.map((item, index) => (
                <FadeIn key={index} delay={index * 0.15}>
                  <div className="group border-b border-warm-stone/40 pb-10 md:pb-14">
                    <span className="font-serif text-3xl md:text-4xl text-estate-bronze/30 mb-4 block italic group-hover:text-estate-bronze transition-colors duration-700">
                      0{index + 1}
                    </span>
                    <h3 className="text-2xl md:text-3xl lg:text-4xl text-deep-charcoal mb-5 group-hover:translate-x-2 transition-transform duration-500">
                      {item.title}
                    </h3>
                    <p className="text-base md:text-lg text-deep-charcoal/60 font-light leading-relaxed max-w-2xl">
                      {item.desc}
                    </p>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}